// Tipos de desenho das peças e zonas onde o nome pode ser colocado. A Alexandra escolhe, por produto, quais destas zonas
// ficam disponíveis (painel, Produto, Personalização). As coordenadas são do desenho (400 x 500).

export const artOf = (p, formato) => {
  const slug = p?.slug ?? "";
  const cat = p?.category ?? "";
  if (cat === "porta-chupetas" || slug === "porta-chupetas") return "urso";
  if (slug === "babete-lenco" || (slug === "babete" && formato === "lenco")) return "babete-lenco";
  if (slug === "pack-4-babetes") return "pack-babetes";
  if (cat === "babetes") return "babete-flor";
  if (cat === "tapa-fraldas") return "tapa-fraldas";
  if (slug === "muda-fraldas-portatil") return "muda-fraldas";
  if (slug === "conjunto-porta-fraldas-muda-fraldas") return "conjunto";
  if (slug === "porta-documentos") return "documentos";
  if (cat === "porta-fraldas") return "porta-fraldas";
  if (slug === "pack-3-saquinhos") return "pack-saquinhos";
  if (cat === "saquinhos") return "saquinho";
  if (cat === "coelhinhos") return "coelho";
  return null;
};

const z = (id, label, x, y, width, size, rotate = 0) => ({ id, label, x, y, width, size, rotate });

export const ART_ZONES = {
  saquinho: [z("centro", "Ao centro", 200, 340, 120, 42), z("cima", "Em cima", 200, 290, 120, 42), z("baixo", "Em baixo", 200, 395, 120, 42)],
  "babete-flor": [z("frente", "Na frente, ao centro", 200, 288, 120, 38), z("baixo", "Em baixo", 200, 332, 100, 30)],
  "babete-lenco": [z("frente", "Na frente, ao centro", 200, 312, 120, 38), z("baixo", "Perto do bico", 200, 372, 84, 28)],
  "tapa-fraldas": [z("frente", "Na frente", 200, 270, 130, 40), z("cinta", "Na cintura", 200, 152, 170, 22)],
  "porta-fraldas": [z("cima", "Em cima", 293, 280, 90, 28), z("baixo", "Em baixo", 293, 352, 90, 28)],
  "muda-fraldas": [z("cima", "Em cima", 232, 150, 100, 34), z("baixo", "Em baixo", 232, 300, 100, 34)],
  conjunto: [z("grande", "Peça grande", 212, 148, 84, 30), z("pequeno", "Peça pequena", 346, 388, 56, 18)],
};

export const zonesOfArt = (art) => ART_ZONES[art] ?? [];
export const zoneGeometry = (art, id) => {
  const list = zonesOfArt(art);
  return list.find((x) => x.id === id) ?? list[0] ?? null;
};
